var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { buildSpacingProps } from '../../helpers/builders';
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  transition: border 0.2s;\n  ", ";\n"], ["\n  cursor: pointer;\n  transition: border 0.2s;\n  ", ";\n"])), buildSpacingProps);
export var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
export var PopoverContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 304px;\n"], ["\n  width: 304px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
